import { memo } from 'react'
import { cn } from '@/lib/utils'

const StatusChangeTooltip = memo(
    ({
        type,
        action,
        userTime,
        adAccountTime,
        originIcon: OriginIcon,
        actionIcon: ActionIcon,
        oldStatus,
        newStatus,
    }) => {
        // Determine entity type and status
        const isTurnedOn = type.includes('turned_on')
        const entityType = type.includes('campaign') ? 'Campaign' : type.includes('adset') ? 'Ad set' : 'Ad'

        const originLabel =
            action.origin === 'meta'
                ? 'Meta Platform'
                : action.origin === 'system'
                  ? 'Turba App'
                  : action.actor_name || 'Manual Action'

        // Hardcode status display based on action type
        // Turned on: Paused → Active
        // Turned off: Active → Paused
        const displayOldStatus = isTurnedOn ? 'Paused' : 'Active'
        const displayNewStatus = isTurnedOn ? 'Active' : 'Paused'

        return (
            <div className={cn('tw:flex tw:flex-col tw:gap-6 tw:w-[290px] tw:box-border', 'tw:bg-[#071727]')}>
                <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
                    <div className="tw:flex tw:items-center tw:gap-3">
                        <div className="tw:relative tw:cursor-help tw:inline-block">
                            <ActionIcon size={27} />
                            {/* Origin indicator positioned at bottom-right corner */}
                            <div className="tw:absolute tw:bottom-0 tw:right-0 tw:translate-x-1/4 tw:translate-y-1/4">
                                <OriginIcon size={10} />
                            </div>
                        </div>
                        <div className="tw:flex tw:flex-col tw:gap-1">
                            <div className="tw:flex tw:items-center tw:gap-2">
                                <span className="tw:text-sm tw:font-medium tw:text-white">
                                    {entityType}{' '}
                                    <span className={cn(isTurnedOn ? 'tw:text-[#4DD15E]' : 'tw:text-[#E0295E]')}>
                                        turned {isTurnedOn ? 'on' : 'off'}
                                    </span>{' '}
                                    by {originLabel}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="tw:flex tw:items-center tw:gap-2">
                    <div className="tw:text-xl">{displayOldStatus}</div>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14 8L18 12M18 12L14 16M18 12H6"
                            stroke="#899CBD"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <div className="tw:text-xl">{displayNewStatus}</div>
                </div>

                <div className="tw:flex tw:justify-between">
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">User Time</span>
                        <span className="tw:text-sm">{userTime}</span>
                    </div>
                    <div className="tw:flex tw:flex-col tw:gap-1">
                        <span className="tw:text-sm tw:font-semibold">Ad Account Time</span>
                        <span className="tw:text-sm">{adAccountTime}</span>
                    </div>
                </div>
            </div>
        )
    },
)

StatusChangeTooltip.displayName = 'StatusChangeTooltip'

export default StatusChangeTooltip
